<template>
  <Row class-name="bodys" :style="{ 'min-height': `${$store.state.init.offsetHeight - 251}px` }">
    <Col :span="24">
      <Breadcrumb class="breadcrumb" separator=">">
        <BreadcrumbItem to="home">首页</BreadcrumbItem>
        <BreadcrumbItem>{{ menuItem[type] }}</BreadcrumbItem>
      </Breadcrumb>
    </Col>
    <Col :span="24">
      <MyList
        ref="myList"
        :type="type"
        :api="GetNewsinfos"
        :automatic="false"
        cellStyle="padding: 14px 16px;border-bottom: 1px solid #e5e5e5;"
      />
    </Col>
  </Row>
</template>

<script>
import MyList from '@components/list'
import { GetNewsinfos } from '@api'
export default {
  name: 'news',
  components: { MyList },
  data () {
    return {
      type: '',
      GetNewsinfos
    }
  },
  async mounted () {
    this.type = this.$route.query.type || '2'
    await this.$nextTick()
    this.$refs['myList'].getPage()
  },
  computed: {
    menuItem () {
      const { cardTitle } = window.config
      return {
        3: cardTitle[0],
        2: cardTitle[1]
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@theme/globle.scss';
$md: 768px;
.bodys {
  background: #fff;
  padding: 16px;
}
.breadcrumb {
  height: 30px;
  border-bottom: 2px solid $default;
}
</style>
